// TabComponent.jsx
import React from 'react';

import PlateWell from "../../../components/platewells/PlateWell";
import PlateEdit from '../../../components/platewells/PlateEdit';
import PlateToolBar from '../../platewells/PlateToolBar';
import QlpFileDownload from '../../platewells/fileDownloads/QlpFileDownload';
import "../../../components/platewells/PlateWell.css";

const DisplaySettings = ({ label, content }) => {
    return (
        <>
            <div className="flex flex-grow  min-h-sreen border-2 border-solid">
                {/* <div className="max-w-[900px] mx-auto space-y-6"> */}

                <div className="flex flex-col w-[100vmin] relative">
                    <div className="flex p-2 w-full">
                        <div className='flex-1'>
                            <PlateToolBar />
                        </div>
                        <div className='p-2 gap-x-32'>
                            <QlpFileDownload />
                        </div>
                    </div>
                    {/* <div className="flex-grow p-1 overflow-auto max-w-[900px] mx-auto space-y-6"> */}
                    <div className="overflow-auto p-2 max-h-[600vmin] space-y-6">
                        <PlateWell />
                    </div>

                </div>
                <div className="w-1/4">
                    <div className='plate-control-panel'>
                        <PlateEdit />
                    </div>
                </div>

                {/* 
                </div> */}
            </div>
            <div className="footer-area">
            </div>

        </>
    );
};

export default DisplaySettings;
